/**
 * Whether the lit tab of the phone bottom bar has room to show its name.
 *
 * At 320px the pill next to the round + is about 224px wide. The four tabs
 * need 44px each to stay tappable, which leaves too little for "Startseite"
 * or "Startpagina": the lit tab pushed Konto/Account under the + (audit
 * 2026-11-02). When the name does not fit whole, the lit tab drops to its
 * icon in the well, the name stays for screen readers, and nothing is cut
 * mid-word.
 *
 * The numbers mirror the classes in mobile-bottom-bar.tsx: keep them in step.
 */
export const BAR_TAB_MIN = 44; // min-w-[44px] on every tab
export const BAR_PILL_PAD = 12; // p-1.5, both sides
export const BAR_TAB_GAP = 2; // gap-0.5 between tabs
export const BAR_LIT_CHROME = 32 + 20 + 6; // px-4 both sides, icon, gap-1.5

export function activeLabelFits(pillWidth: number, labelWidth: number, tabCount: number): boolean {
  if (pillWidth <= 0 || labelWidth <= 0) return true; // not measured yet
  const others = (tabCount - 1) * BAR_TAB_MIN;
  const gaps = (tabCount - 1) * BAR_TAB_GAP;
  // Round the label up: a fraction of a pixel short still clips the last letter.
  return BAR_PILL_PAD + gaps + others + BAR_LIT_CHROME + Math.ceil(labelWidth) <= pillWidth;
}
